export const RECRUITER_COLORS = ['blue', 'red', 'yellow', 'orange', 'green', 'teal', 'cyan', 'purple', 'pink', 'gray'] as const;

export const GMAIL_COLORS = ['green', 'orange', 'pink', 'cyan', 'purple'] as const;

export const OUTLOOK_COLORS = ['red', 'teal', 'yellow', 'gray', 'blue'] as const;

export type RecruiterColor = typeof RECRUITER_COLORS[number];

export const STRIPE_GRADIENT = (baseColor: string): string =>
  `repeating-linear-gradient(45deg, ${baseColor} 0px, #ffffff 10px, ${baseColor} 10px, ${baseColor} 10px)`;
